import {Notif} from "@/js/global/components/Notif";

/**
 * @var localizedScript
 */
export const cancelSubscription = ()=>{
    const buttons = document.querySelectorAll('.cancel-subscription-js');

    if (!buttons.length) return;
    buttons.forEach(btn => {
        btn.addEventListener('click', async (e) => {
            e.preventDefault();

            const subscriptionId = btn.dataset.subscription_id;
            const nonce = btn.dataset.nonce;

            if (!subscriptionId || !nonce) {
                Notif.show('error','Missing subscription ID or nonce');
                return;
            }

            const confirmed = await Notif.confirm(
                'Are you sure you want to cancel your subscription? This action cannot be undone.'
            ).catch(() => false);

            if (!confirmed) return;

            btn.disabled = true;
            const originalText = btn.innerText;
            btn.innerText = 'Processing...';
            const ajaxUrl = localizedScript.ajax_url;

            try {
                const res = await fetch(ajaxUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: new URLSearchParams({
                        action: 'cancel_subscription',
                        subscription_id: subscriptionId,
                        nonce: nonce
                    })
                });

                const json = await res.json();

                if (!json.success) {
                    Notif.show('error',json.data?.message || 'Error cancelling subscription');
                    btn.disabled = false;
                    btn.innerText = originalText;
                    return;
                }
                Notif.show('success',json.data.message);
                setTimeout(() => {
                    window.location.reload();
                }, 5000);


            } catch (error) {
                console.error(error);
                Notif.show('error','Network error. Please try again.');
                btn.disabled = false;
                btn.innerText = originalText;
            }
        });
    });
}